import { createQueryKeyStore } from '@lukemorales/query-key-factory'

import type { RedemptionFilters } from './types'

export const keys = createQueryKeyStore({
  admin_redeemables: {
    all: null,
    detail: (id: string) => [id],
  },
  admin_redemptions: {
    list: (filters: RedemptionFilters) => [filters],
    detail: (id: string) => [id],
  },
  liquidity_providers: {
    all: null,
  },
})
